import { render, staticRenderFns } from "./SoalList.vue?vue&type=template&id=7ab5f16b&scoped=true"
import script from "./SoalList.vue?vue&type=script&lang=js"
export * from "./SoalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab5f16b",
  null
  
)

export default component.exports